import * as yup from 'yup';
import { Fields } from '../models/fields';
import { useTranslation } from '~/shared/utils/translation';
import { passwordRegex } from '~/shared/utils';
export const useValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        [Fields.Email]: yup.string().email(translate('message.emailValidationError')),

        [Fields.NewPassword]: yup
            .string()
            .matches(passwordRegex, translate('message.passwordHelpText')),

        /**/
        [Fields.RepeatPassword]: yup
            .string()
            .oneOf([yup.ref('newpassword'), null], translate('createAccount.passwordMismatch')),
    });
};

export const useResetPasswordValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        [Fields.NewPassword]: yup
            .string()
            .required('')
            .matches(passwordRegex, translate('message.passwordHelpText')),

        /**/
        [Fields.RepeatPassword]: yup
            .string()
            .required('')
            .oneOf(
                [yup.ref(Fields.NewPassword), null],
                translate('createAccount.passwordMismatch'),
            ),
    });
};

export const useChangePasswordValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        // Current password
        [Fields.Password]: yup.string().required(''),

        // New password
        [Fields.NewPassword]: yup
            .string()
            .required('')
            .matches(passwordRegex, translate('message.passwordHelpText'))
            .test(
                'not-same-as-old',
                translate('message.passwordValidationError.sameAsOld'),
                function (value) {
                    const { parent } = this;
                    return value !== parent[Fields.Password];
                },
            ),

        // Confirm new password
        [Fields.RepeatPassword]: yup
            .string()
            .required('')
            .oneOf(
                [yup.ref(Fields.NewPassword), null],
                translate('message.passwordValidationError.dontMatch'),
            ),
    });
};
